import { render, staticRenderFns } from "./orderRepayment.vue?vue&type=template&id=3877c018&scoped=true&"
import script from "./orderRepayment.vue?vue&type=script&lang=js&"
export * from "./orderRepayment.vue?vue&type=script&lang=js&"
import style0 from "./orderRepayment.vue?vue&type=style&index=0&id=3877c018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877c018",
  null
  
)

export default component.exports